import React from 'react';

import { ApIcon, colors } from '@alixpartners/ui-components';
import { Wrapper, Label, IconWrapper } from './FilterChip.styles';

interface IProps {
  label: string;
  onDismiss?(): void;
  onClick?(): void;
  values?: string[];
  isSelected?: boolean;
  isDisabled?: boolean;
}

export const FilterChip: React.FC<IProps> = ({
  label,
  onDismiss,
  onClick,
  isSelected,
  isDisabled,
  values,
}) => {
  const hasValues = values && values.length > 0;
  const title =
    values && values.length > 0
      ? values.length === 1
        ? values[0]
        : `${label} (${values.length})`
      : label;

  return (
    <Wrapper
      isSelected={isSelected}
      isActive={hasValues}
      isDisabled={isDisabled}
      isDismissible={hasValues && !!onDismiss}
      onClick={onClick}
    >
      <Label title={title}>{title}</Label>
      {hasValues && onDismiss && (
        <IconWrapper
          onClick={(e: any) => {
            e.stopPropagation();
            onDismiss();
          }}
        >
          <ApIcon
            iconName="outline_cancel"
            iconColor={colors.white}
            iconSize={20}
          />
        </IconWrapper>
      )}
    </Wrapper>
  );
};
